import { BaseURIHolder } from './BaseURIHolder';
import UnAuthService from '../auth/UnAuthService';

export class NetiFileHandler {
    constructor() {
        this.baseURIHolder = new BaseURIHolder();
        this.unAuth = new UnAuthService();
    }

    getByteImage(filePath) {
        var uri = this.baseURIHolder.getGuestFile() + '/find?filePath=' + filePath;
        return this.unAuth.getFetch(uri);
    }

    getImageExtention(contentType) {
        if (contentType === undefined) {
            return;
        }
        let extention = '';
        if (contentType === 'image/jpeg') {
            extention = '.jpeg';
        } else if (contentType === 'image/jpg') {
            extention = '.jpg';
        } else if (contentType === 'image/png') {
            extention = '.png';
        } else if (contentType === 'application/pdf') {
            extention = '.pdf';
        } else if (contentType === 'application/msword') {
            extention = '.doc';
        } else if (contentType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
            extention = '.docx';
        } else if (contentType === 'application/vnd.ms-excel') {
            extention = '.xls';
        } else if (contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            extention = '.xlsx';
        } else if (contentType === 'application/vnd.ms-powerpoint') {
            extention = '.ppt';
        } else if (contentType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
            extention = '.pptx';
        }
        return extention;
    }

    getImageContentType(fileName) {
        if (fileName === undefined) {
            return;
        }
        let contentType = '';
        if (fileName.endsWith('.jpeg')) {
            contentType = 'image/jpeg';
        } else if (fileName.endsWith('.jpg')) {
            contentType = 'image/jpg';
        } else if (fileName.endsWith('.png')) {
            contentType = 'image/png';
        } else if (fileName.endsWith('.pdf')) {
            contentType = 'application/pdf';
        }
        return 'data:' + contentType + ';base64,';
    }

    getFileContentType(fileName) {
        if (fileName === undefined) {
            return;
        }
        let contentType = '';
        if (fileName.endsWith('.jpeg')) {
            contentType = 'image/jpeg';
        } else if (fileName.endsWith('.jpg')) {
            contentType = 'image/jpg';
        } else if (fileName.endsWith('.png')) {
            contentType = 'image/png';
        } else if (fileName.endsWith('.pdf')) {
            contentType = 'application/pdf';
        } else if (fileName.endsWith('.doc')) {
            contentType = 'application/doc';
        } else if (fileName.endsWith('.docx')) {
            contentType = 'application/docx';
        } else if (fileName.endsWith('.xls')) {
            contentType = 'application/xls';
        } else if (fileName.endsWith('.xlsx')) {
            contentType = 'application/xlsx';
        } else if (fileName.endsWith('.ppt')) {
            contentType = 'application/ppt';
        } else if (fileName.endsWith('.pptx')) {
            contentType = 'application/pptx';
        }
        return contentType;
    }

    getResizeByteImage(realContent, fileName, width, height) {
        let output = '';
        if (realContent === undefined || realContent == null) {
            return;
        }
        if (fileName === undefined || fileName == null) {
            return;
        }
        let contentType = this.getImageContentType(fileName);
        width = width ? width : 150;
        height = height ? height : 150;
        let fileType = this.getFileContentType(fileName);
        return new Promise(function (resolve, reject) {
            try {
                let img = new Image();
                img.src = contentType + realContent;
                img.onload = () => {
                    if (img.height > img.width) {
                        width = Math.floor(height * (img.width / img.height));
                    }
                    else {
                        height = Math.floor(width * (img.height / img.width));
                    }

                    let resizingCanvas = document.createElement('canvas');
                    let resizingCanvasContext = resizingCanvas.getContext("2d");
                    resizingCanvas.width = img.width;
                    resizingCanvas.height = img.height;
                    resizingCanvasContext.drawImage(img, 0, 0, resizingCanvas.width, resizingCanvas.height);

                    let curImageDimensions = {
                        width: Math.floor(img.width),
                        height: Math.floor(img.height)
                    };

                    let halfImageDimensions = {
                        width: null,
                        height: null
                    };

                    // Quickly reduce the dize by 50% each time in few iterations until the size is less then
                    // 2x time the target size - the motivation for it, is to reduce the aliasing that would have been
                    // created with direct reduction of very big image to small image
                    while (curImageDimensions.width * 0.5 > width) {
                        // Reduce the resizing canvas by half and refresh the image
                        halfImageDimensions.width = Math.floor(curImageDimensions.width * 0.5);
                        halfImageDimensions.height = Math.floor(curImageDimensions.height * 0.5);

                        resizingCanvasContext.drawImage(resizingCanvas, 0, 0, curImageDimensions.width, curImageDimensions.height,
                            0, 0, halfImageDimensions.width, halfImageDimensions.height);

                        curImageDimensions.width = halfImageDimensions.width;
                        curImageDimensions.height = halfImageDimensions.height;
                    }

                    // Now do final resize for the resizingCanvas to meet the dimension requirments
                    // directly to the output canvas, that will output the final image
                    let outputCanvas = document.createElement('canvas');
                    let outputCanvasContext = outputCanvas.getContext("2d");

                    outputCanvas.width = width;
                    outputCanvas.height = height;

                    outputCanvasContext.drawImage(resizingCanvas, 0, 0, curImageDimensions.width, curImageDimensions.height,
                        0, 0, width, height);

                    // output the canvas pixels as an image. params: format, quality
                    output = outputCanvas.toDataURL(fileType, 0.85);
                    resolve(output);
                };
            } catch (e) {
                reject(e);
            }

        })

    }

    formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    getFileSizeError(fileSize, maxFileSize) {
        // let fileSize = maxFileSize/1024
        // if(maxFileSize => 1024000 && maxFileSize <= 1000000){

        // }
        // console.log('this.formatBytes(maxFileSize)', this.formatBytes(maxFileSize));

        if (fileSize > maxFileSize) {
            return this.formatBytes(maxFileSize)
        }
        else {
            return ''
        }
    }

    getMaxFileSizeIsValid(fileSize, maxFileSize) {

        // file must be in byte
        if (fileSize < maxFileSize) {
            return true;
        } else { return false }

    }

}